declare namespace $ {

	export class $shm_hitalama_map_widget_float_table_follower extends $mol_follower {
		zoom( ): number
	}
	
}

//# sourceMappingURL=follower.view.tree.d.ts.map